module.exports = __webpack_public_path__ + "a381bb313aa9bfb17294b40d81fb3678.svg";